import React from "react";

import * as S from "./styles";
import { IProps } from "./types";

export const InputLabel: React.FC<IProps> = ({
  children,
  active,
  labelBackground,
  isProductPage
}: IProps) => {
  return <S.Label {...{ active, isProductPage, labelBackground }}>{children}</S.Label>;
};
